import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-days-yesterday',
  templateUrl: './select-days-yesterday.component.html',
  styleUrls: ['./select-days-yesterday.component.scss']
})
export class SelectDaysYesterdayComponent implements OnInit, OnDestroy {

  @Input() section: any = false;
  public items: any[] = [
    { value: 1, name: 'Ayer' },
    { value: 7, name: 'Últ. 7 días' },
    { value: 14, name: 'Últ. 14 días' },
    { value: 30, name: 'Últ. 30 días' },
    { value: 99, name: 'Mes Actual' },
    { value: 0, name: 'Mes Anterior' }
  ];

  public daysAgoYesterday: any = [];
  public ngxDisabled = false;
  daysAgoYesterday$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.daysAgoYesterday$ = this.sharedService.sharedDaysAgoYesterday.subscribe(daysAgoYesterday => {
      this.daysAgoYesterday = daysAgoYesterday;
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnInit(): void {
    if (this.section) {
      this.daysAgoYesterday = 30;
    } else {
      this.daysAgoYesterday = 14;
    }
   }

  ngOnDestroy() {
    this.daysAgoYesterday$.unsubscribe();
  }

  changeDaysAgo(event: any) {
    this.daysAgoYesterday = event;
    this.sharedService.nextDaysAgoYesterday = this.daysAgoYesterday;
  }
}
